export default __webpack_public_path__ + "static/media/clearFiltersNew.95e02f1b.svg";